import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import {
    SuperAdminApartmentAmenityDto,
    SuperAdminApartmentListItemDto,
    SuperAdminApartmentPhotoDto,
} from '@/features/superAdmin/features/data/types/superAdmin-data.types';
import {
    formatBoolean,
    formatNavValue,
} from '@/features/superAdmin/features/data/shared/utils/superAdminDataFormatters';

export const useSuperAdminRoomsPageColumns = () => {
    const { t } = useTranslation();

    const columns: ColumnDef<SuperAdminApartmentListItemDto>[] = [
        { accessorKey: 'id', header: t('superAdmin.data.columns.id') },
        {
            accessorKey: 'tenantName',
            header: t('superAdmin.data.columns.tenant'),
            cell: ({ row }) => formatNavValue(row.original.tenantId, row.original.tenantName),
        },
        { accessorKey: 'name', header: t('superAdmin.data.rooms.columns.name') },
        {
            accessorKey: 'hotelName',
            header: t('superAdmin.data.columns.hotel'),
            cell: ({ row }) => formatNavValue(row.original.hotelId, row.original.hotelName),
        },
        {
            accessorKey: 'ownerName',
            header: t('superAdmin.data.columns.owner'),
            cell: ({ row }) => formatNavValue(row.original.ownerId, row.original.ownerName),
        },
        {
            accessorKey: 'apartmentTypeName',
            header: t('superAdmin.data.rooms.columns.apartmentType'),
            cell: ({ row }) => formatNavValue(row.original.apartmentTypeId, row.original.apartmentTypeName),
        },
        { accessorKey: 'cadastralCode', header: t('superAdmin.data.rooms.columns.cadastralCode') },
        { accessorKey: 'squareness', header: t('superAdmin.data.rooms.columns.squareness') },
        {
            accessorKey: 'isVirtual',
            header: t('superAdmin.data.rooms.columns.isVirtual'),
            cell: ({ row }) => formatBoolean(row.original.isVirtual),
        },
        {
            accessorKey: 'deletionMark',
            header: t('superAdmin.data.columns.deletionMark'),
            cell: ({ row }) => formatBoolean(row.original.deletionMark),
        },
        { accessorKey: 'externalId', header: t('superAdmin.data.columns.externalId') },
    ];

    return columns;
};

export const roomAmenityNestedColumns: ColumnDef<SuperAdminApartmentAmenityDto>[] = [
    { accessorKey: 'amenityId', header: 'AmenityId' },
    { accessorKey: 'amenityName', header: 'AmenityName' },
];

export const roomPhotoNestedColumns: ColumnDef<SuperAdminApartmentPhotoDto>[] = [
    { accessorKey: 'id', header: 'Id' },
    { accessorKey: 'name', header: 'Name' },
    { accessorKey: 'url', header: 'Url' },
];
